var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutographIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28366 8.28366L10.0003 7.50033L8.28366 6.71699L7.50033 5.00033L6.71699 6.71699L5.00033 7.50033L6.71699 8.28366L7.50033 10.0003L8.28366 8.28366ZM16.667 11.667L15.8837 9.95033L14.167 9.16699L15.8837 8.38366L16.667 6.66699L17.4503 8.38366L19.167 9.16699L17.4503 9.95033L16.667 11.667ZM12.917 7.50033L12.0087 5.49199L10.0003 4.58366L12.0087 3.67533L12.917 1.66699L13.8253 3.67533L15.8337 4.58366L13.8253 5.49199L12.917 7.50033ZM16.2503 17.0837L11.2503 12.0753L7.91699 15.4087L0.83366 7.44199L2.00866 6.26699L7.91699 12.9087L11.2503 9.57533L17.5003 15.8337L16.2503 17.0837Z",
    fill: "#003785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutographIcon);
export default __webpack_public_path__ + "static/media/autograph-icon.86fd27bd036c0dfbb35f288384cbbe57.svg";
export { ForwardRef as ReactComponent };